import { IShared } from "../../models/shared";
import { SharedState } from "../states/shared.state";
import { SharedActions } from "../actions/shared.action";
import { ESharedActions } from "../actions/shared.action";

export function SharedReducer(
  state: IShared = SharedState,
  action: SharedActions,
): IShared {
  switch (action.type) {
    case ESharedActions.FetchRealEstateTypesAttempt: {
      return { ...state };
    }
    case ESharedActions.FetchRealEstateTypesSuccess: {
      return { ...state, realEstateTypes: action.payload };
    }
    case ESharedActions.FetchRealEstateTypesFailed: {
      return { ...state };
    }
    case ESharedActions.FetchAuctionStatusesAttempt: {
      return { ...state };
    }
    case ESharedActions.FetchAuctionStatusesSuccess: {
      return { ...state, auctionStatuses: action.payload };
    }
    case ESharedActions.FetchAuctionStatusesFailed: {
      return { ...state };
    }
    default:
      return state;
  }
}
